export default __webpack_public_path__ + "static/media/backpackWoman.9f7a0f4a.png";